export const market = process.env.REACT_APP_MARKET;

export const whatsAppContactUs = process.env.REACT_APP_WHATSAPP_CONTACT_US;
export const whatsAppContactUsUrl = process.env.REACT_APP_WHATSAPP_URL;
export const callCenterContactUs = process.env.REACT_APP_CALL_CENTER_CONTACT_US;
export const emailContactUs = process.env.REACT_APP_EMAIL_CONTACT_US;

export const sgoBillImageUrl = process.env.REACT_APP_SGO_BILL_IMAGE_URL;
